import { BooleanField, TextAreaInput, TextField, TextFieldInputProps } from "@hex-insights/forms";
import { StudentMedicalConditionFormValues } from "../../FormUtilities";
import { MedicalConditionSelectField } from "../MedicalCondition";
import { BaseFieldProps } from "../shared";
import { StudentSelectField } from "../Student";

/**
 * Generic props for fields of the StudentMedicalCondition model.
 */
type FieldProps<K extends keyof StudentMedicalConditionFormValues.Base = keyof StudentMedicalConditionFormValues.Base> =
	BaseFieldProps<Pick<StudentMedicalConditionFormValues.Base, K>>;

/**
 * Field component for the `isProminent` field of the StudentMedicalCondition model.
 */
export function IsProminent({
	formState,
	label = "Display prominently",
	hint = "Causes this condition to be shown more visibly. Use for conditions that are very severe or important.",
	...props
}: FieldProps<"isProminent">) {
	return <BooleanField formState={formState} name="isProminent" label={label} hint={hint} {...props} />;
}

/**
 * Field component for the `notes` field of the StudentMedicalCondition model.
 */
export function Notes({ formState, ...props }: FieldProps<"notes">) {
	return <TextField formState={formState} name="notes" multiLine optional Input={NotesInput} {...props} />;
}

function NotesInput(props: TextFieldInputProps) {
	return <TextAreaInput minRows={2} {...props} />;
}

export namespace MedicalCondition {
	export type SelectProps = FieldProps<"medicalConditionID"> &
		Omit<
			MedicalConditionSelectField.SelectProps<StudentMedicalConditionFormValues.Base>,
			"formState" | "name" | "optional"
		>;

	/**
	 * Field component for the `medicalCondition` edge of the StudentMedicalCondition model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <MedicalConditionSelectField.Select formState={formState} name="medicalConditionID" {...props} />;
	}
}

export namespace Student {
	export type SelectProps = FieldProps<"studentID"> &
		Omit<StudentSelectField.SelectProps<StudentMedicalConditionFormValues.Base>, "formState" | "name" | "optional">;

	/**
	 * Field component for the `student` edge of the StudentMedicalCondition model.
	 */
	export function Select({ formState, ...props }: SelectProps) {
		return <StudentSelectField.Select formState={formState} name="studentID" {...props} />;
	}
}
